import PubSub from 'pubsub-js'

import { PubSubEvents } from '@shared/hooks/src/usePubSub'

/**
 * Triggers the animated background to shuffle/reposition all blobs
 * Useful for triggering on page transitions or other events
 */
export function shuffleAnimatedBackground() {
  PubSub.publish(PubSubEvents.AnimatedBackgroundShuffle)
}
